export function appleMapsUrl(destAddress: string, originAddress?: string): string {
  const params = new URLSearchParams({ daddr: destAddress, dirflg: 'd' });
  if (originAddress) params.set('saddr', originAddress);
  return `https://maps.apple.com/?${params.toString()}`;
}

export function googleMapsUrl(destAddress: string, originAddress?: string): string {
  const params = new URLSearchParams({
    api: '1',
    destination: destAddress,
    travelmode: 'driving',
  });
  if (originAddress) params.set('origin', originAddress);
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}

export function wazeUrl(lat: number, lng: number): string {
  const params = new URLSearchParams({ ll: `${lat},${lng}`, navigate: 'yes' });
  return `https://waze.com/ul?${params.toString()}`;
}

export function telUrl(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}
